import React, { Component } from 'react';
import api from '../../../api/api';
import DateFilter from '../../../components/ParadigmaTable/DateFilter';
import ParadigmaTable from '../../../components/ParadigmaTable/ParadigmaTable';
import dateFunctions from '../../functions/dateFunctions';
import auth from '../../../auth/';
import ParadigmaAsyncSeeker from '../../../components/ParadigmaAsyncSeeker_v2/ParadigmaAsyncSeeker';
import Modal from '../../Convenios/Modal'

class ConsultaConvenios extends Component {
    constructor(props){
        super(props);
        this.state = {
            filter: [],
            personal_id: null,
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    show: false,
                    private: true,
                    filterable: false,
                },
                {
                    Header: "Titulo",
                    id: "titulo",
                    accessor: "titulo",
                    show: true,
                    filterable: true,
                    width: 300,
                },
                // {
                //     Header: "Contraparte",
                //     id: "empresa",
                //     accessor: "empresa",
                //     show: true,
                //     filterable: true,
                // },
                {
                    Header: "Dependencia",
                    id: "nombredependenciaconvenio",
                    accessor: "nombredependenciaconvenio",
                    show: true,
                    filterable: true,
                    width: 100,
                },
                {
                    Header: "Referencia",
                    id: "referencia",
                    accessor: "referencia",
                    show: true,
                    filterable: true,
                    width: 300,
                },
                {
                    Header: "Tipo",
                    id: "nombretipoconvenio",
                    Cell: d=> (d.original.nombretipoconvenio),
                    show: true,
                    filterable: true,
                },
                {
                    Header: "Proyecto",
                    id: "solicitud",
                    Cell: (c) => c.original.solicitud ? c.original.solicitud : '',
                    show: true,

                },
                {
                    Header: "Fecha Inicio",
                    id: "fecha_inicio",
                    width: 170,
                    className: "text-center",
                    accessor: d => dateFunctions.parseDate(d.fecha_inicio),
                    show: true,
                    filterable: true,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />
                },
                {
                    Header: "Fecha Vencimiento",
                    id: "fecha_vencimiento",
                    width: 170,
                    className: "text-center",
                    accessor: d => dateFunctions.parseDate(d.fecha_vencimiento),
                    show: true,
                    filterable: true,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />
                },
            ]
        }
    }


    onChangeUsuario(data) {
        let filter = [];
        if (data) {
            filter.push({ 'id': 'participantes__pk', 'value': [data].map(x => x.id).join(',') });
        }
        this.setState({ personal_id: data ? data.id : null, filter: filter });
    }

  render() {

    return (
      <ParadigmaTable
        buttons={[
            {
                detail: true,
                permission: 'consultas_convenios_detail',
                component: (props) => <Modal {...props} action="DETAIL"/>
            },
        ]}
        apiUrl={api.proyectos.cargadatos.convenios.list}
        // apiUrl={api.convenios.convenios.list}
        columns={this.state.columns}
        title={"Convenios"}
        outerFilter={this.state.filter}
        customSearchElement={
            (auth.hasPermission('administrador') || auth.hasPermission('soberana')
                ? <div className="ui-table-filter ui-form">
                    <section className="ui-section-block ">
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <label>Personal</label>
                                <ParadigmaAsyncSeeker
                                    fieldName={""}
                                    clearable={false}
                                    displayField={"fullname"}
                                    url={api.usuarios.personal.select}
                                    onChange={(data) => this.onChangeUsuario(data)}
                                    value={this.state.personal_id}
                                />
                            </div>
                        </div>
                    </section>
                </div>
                : <div></div>
            )
        }
      />
      )
  }
}

export default ConsultaConvenios;



// WEBPACK FOOTER //
// ./src/views/Consultas/Convenios/Convenios.js